import React from "react";
import ResultsCount from "../new-category/wrapper/results-count";
import useAlgoliaSorting from "@/hooks/algolia/useAlgoliaSorting";

const SortingAndSearchCount = ({
  totalProduct,
  page,
  t,
  setCurrentRefinement,
  currentRefinement,
}) => {
  const {
    sortMenuRef,
    show,
    setShow,
    optionsData,
    selectedOption,
    handleSelection,
  } = useAlgoliaSorting(t, currentRefinement, setCurrentRefinement);
  return (
    <div className="max-[768px]:hidden flex justify-between items-center border rounded-md p-3 mb-4">
      {/* Sorting dropdown */}
      <div className="flex items-center gap-2">
        <span>{t("SortBy")}</span>
        <div ref={sortMenuRef} className="relative">
          <div
            onClick={() => setShow((prev) => !prev)}
            className="flex items-center overflow-hidden bg-white border rounded-md cursor-pointer hover:bg-gray-50 min-w-36"
          >
            <span className="flex-grow px-4 py-2 text-gray-600 text-sm/none hover:text-gray-700">
              {selectedOption?.label || t("Select")}
            </span>
            <button className="h-full p-2 text-gray-600 hover:text-gray-700">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="size-4"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>

          {show && (
            <div
              className="absolute end-0 z-[999] mt-2 min-w-36 rounded-md border border-gray-100 bg-white shadow-lg"
              role="menu"
            >
              <div className="p-2">
                {optionsData?.map((item) => (
                  <button
                    onClick={() => handleSelection(item?.value)}
                    key={item?.value}
                    className={`block w-full text-start rounded-lg px-4 py-2 hover:text-red text-sm text-gray-500 hover:bg-gray-50 ${
                      item?.value === currentRefinement ? "text-red" : ""
                    }`}
                    role="menuitem"
                  >
                    {t(item?.label)}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Display the results count */}
      <ResultsCount t={t} currentPage={page} total={totalProduct} />
    </div>
  );
};

export default SortingAndSearchCount;
